import { utils } from '@/helpers';
import {
	Campaign,
	CampaignChannelType,
	CampaignChannelUnion,
	EmailTemplate,
	VoiceTemplate,
	SMSTemplate,
	PushTemplate,
	BrowserTemplate,
	SnailMailTemplate,
	AdTemplate,
} from '@/types';

/**
 * Get the default channel for a given campaign
 * @param channelType - The type of channel to get the default for
 * @param campaign - The campaign to get the default for
 * @returns The default channel for the given campaign
 */
export function getDefaultChannel<T = CampaignChannelUnion>(channelType: CampaignChannelType, campaign: Campaign): T {
	switch (channelType) {
		case CampaignChannelType.Email:
			return getDefaultEmailTemplate(campaign) as T;
		case CampaignChannelType.Voice:
			return getDefaultVoiceTemplate(campaign) as T;
		case CampaignChannelType.Text:
			return getDefaultSMSTemplate(campaign) as T;
		case CampaignChannelType.Push:
			return getDefaultPushTemplate(campaign) as T;
		case CampaignChannelType.Browser:
			return getDefaultBrowserTemplate(campaign) as T;
		case CampaignChannelType.SnailMail:
			return getDefaultSnailMailTemplate(campaign) as T;
		case CampaignChannelType.Ad:
			return getDefaultAdTemplate(campaign) as T;
		default:
			return {} as T;
	}
}

export function getDefaultEmailTemplate(_?: Partial<Campaign>): EmailTemplate {
	return { inUse: true };
}

export function getDefaultVoiceTemplate(_?: Partial<Campaign>): VoiceTemplate {
	return { inUse: true };
}

export function getDefaultSMSTemplate(campaign?: Partial<Campaign>): SMSTemplate {
	const isAgnostic = utils.isAgnostic();
	const defaultTemplate: SMSTemplate = {
		landingType: campaign?.optinCampaign || campaign?.emailOptinCampaign ? 'RAW' : 'HTML',
		optionType: isAgnostic ? 'regular' : 'regulated',
		msgContainer: utils.user.msgContainer ?? '',
	};
	if (isAgnostic) {
		defaultTemplate.agnostic = true;
		defaultTemplate.msgContainer = undefined;
		defaultTemplate.landingType = undefined;
		defaultTemplate.landingHTML = undefined;
		defaultTemplate.landingDesign = undefined;
	}
	return {
		...defaultTemplate,
		inUse: true,
	};
}

export function getDefaultPushTemplate(_?: Partial<Campaign>): PushTemplate {
	return { inUse: true };
}

export function getDefaultBrowserTemplate(_?: Partial<Campaign>): BrowserTemplate {
	return { inUse: true };
}

export function getDefaultSnailMailTemplate(_?: Partial<Campaign>): SnailMailTemplate {
	return { inUse: true };
}

export function getDefaultAdTemplate(_?: Partial<Campaign>): AdTemplate {
	return { inUse: true };
}
